module.exports = __webpack_public_path__ + "static/media/icon-cancellation-policy.259f1e03.svg";